import { useFeatureFlagsContext } from './use-feature-flags-context.hook';

export const useGetEnabledFeatureFlags = () => {
    const { featureFlags } = useFeatureFlagsContext();

    return featureFlags?.filter((flag) => flag.active).map((flag) => flag.name) || [];
};
